import { Line } from '@ant-design/plots';
import { Card, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import useTime from '../../hooks/useTime';
import dashboardApi from '../../api/home';
import dayjs from 'dayjs';
import { formatShortNumber } from '../../helpers/helpers';
import { formatCurrency, formatNumber } from '../../utils/helpers';
const LAST_30_DAYS = new Date(new Date().setDate(new Date().getDate() - 29));
const RevenueChart = ({ operator, type }) => {
  const { convertToAnyTimezone } = useTime();

  const [dataChart, setDataChart] = useState([]);
  const [loadingChart, setLoadingChart] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      let filter = {
        from_date: convertToAnyTimezone(new Date())
          .startOf('month')
          .format('YYYY/MM/DD'),

        to_date: convertToAnyTimezone(new Date())
          .endOf('month')
          .format('YYYY/MM/DD'),

        mode: 'booking',
        type: type ?? '',
      };

      if (operator) {
        filter = {
          ...filter,
          operator_id: operator,
        };
      }
      setLoadingChart(true);
      const res = await dashboardApi.getRevenue(filter);
      console.log('res', res);

      if (res) {
        setDataChart(res.data);
        setLoadingChart(false);
      }
    };

    fetch();
  }, [operator, type]);

  const config = {
    data: dataChart,
    xField: 'date',
    yField: 'total',
    seriesField: 'title',
    legend: {
      color: {
        layout: {
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
    },
    stack: false,
    animation: {
      appear: {
        animation: 'path-in',
        duration: 1000,
      },
    },
    scale: {
      color: {
        range: ['#2688FF', 'red'],
      },
    },
    shapeField: 'smooth',
    point: {
      shapeField: 'square',
      sizeField: 1,
    },
    style: {
      lineWidth: 2.5,
      stroke: '#3c74ce',
      strokeOpacity: 1,
      lineDash: [0, 0],
    },

    axis: {
      y: {
        position: 'right',
        labelFormatter: (value) => {
          return formatShortNumber(Number(value));
        },
        gridLineWidth: 2,
        gridStroke: '#3c74ce',
        gridLineDash: [0, 0],
      },
      x: {
        labelFormatter: (value) => {
          return dayjs(value, 'YYYY/MM/DD').format('DD MMM YY');
        },
        labelAutoRotate: false,
        labelAutoHide: true,
      },
    },
    interaction: {
      tooltip: {
        render: (e, { title, items }) => {
          const list = items;
          const item = items.find((item) => item.name === 'date');

          return (
            <div key={title}>
              <div>{dayjs(title, 'YYYY/MM/DD').format('DD MMM YY')}</div>
              {list
                .filter((item) => item.name !== 'date' && item.name !== 'total')
                .map((item) => {
                  const { value, name, color } = item;
                  return (
                    <div>
                      <div
                        style={{
                          margin: 0,
                          display: 'flex',
                          justifyContent: 'space-between',
                          minWidth: 150,
                        }}>
                        <div>
                          <span
                            style={{
                              display: 'inline-block',
                              width: 6,
                              height: 6,
                              borderRadius: '50%',
                              backgroundColor: color,
                              marginRight: 6,
                            }}></span>
                          <span>
                            {name === 'Revenue'
                              ? 'Revenus '
                              : name === 'Filling rate'
                                ? 'Taux de remplissage '
                                : name === 'Trips'
                                  ? 'Voyages'
                                  : 'Passagers '}
                          </span>
                        </div>
                        <b>
                          {name === 'Revenue'
                            ? formatCurrency(value)
                            : name === 'Filling rate'
                              ? '  ' + value + ' %'
                              : formatNumber(value ?? 0)}
                        </b>
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        },
      },
    },
  };

  return (
    <React.Fragment>
      <Card style={{ width: '100%' }}>
        <Spin spinning={loadingChart}>
          <Line {...config} />
        </Spin>
      </Card>
    </React.Fragment>
  );
};

export default RevenueChart;
